export default {"src":"/_next/static/media/ls.4be40501.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};